<script lang="ts">
import ModulePreference from '@/generated/modules/ModulePreference.vue';
import Button from '@/framework/base/classes/Button';
import { storeNotif, storeSession } from '@/generated/stores';
import { defineComponent } from "vue";
import {useRoute, useRouter} from "vue-router";

export default defineComponent({
  components: {},
  extends: ModulePreference,
  data() {
    const buttons: Button[] = [];
    return {
      buttons,
      router: useRouter(),
      ciRoute: useRoute()
    };
  },
  computed: {
    extraButtons(): Button[] {
      if (this.buttons.length == 0 && this.isMobile) {
        const logOut = new Button();
        logOut.label = 'Me déconnecter';
        logOut.show = true;
        logOut.disabled = false;
        logOut.outlined = false;
        logOut.loading = false;
        logOut.callback = () => this.logOut(logOut);
        this.addButton(logOut);
      }
      return this.buttons;
    }
  },
  methods: {
    addButton(button: Button) {
      this.buttons.push(button);
    },
    logOut(button: Button): Promise<void> {
      button.loading = true;
      return new Promise((resolve) => {
        if (storeSession.modeLocal) {
          storeSession.clearData();
          if (this.ciRoute.name != "HomePage") {
            this.router.push({ name: "HomePage" });
          }
        } else {
          if (storeSession.logout !== undefined) {
            storeSession.logout().then((res) => {
              if (res) {
                if (this.ciRoute.name != "HomePage") {
                  this.router.push({ name: "HomePage" });
                }
              } else {
                if (this.ciRoute.name != "Dashboard") {
                  this.router.push({ name: "Dashboard" });
                } else {
                  storeNotif.registerNotif();
                }
              }
            });
          }
        }
        resolve();
      });
    }
  }
})

</script>
